// This file is auto-generated by the FontAwesome scanner plugin
// Do not edit manually - it will be overwritten on build

import { library } from '@fortawesome/fontawesome-svg-core';

import {
    faAlignLeft as fasAlignLeft,
    faArrowDown as fasArrowDown,
    faArrowLeft as fasArrowLeft,
    faArrowRight as fasArrowRight,
    faArrowRotateLeft as fasArrowRotateLeft,
    faArrowsAlt as fasArrowsAlt,
    faArrowsRotate as fasArrowsRotate,
    faArrowTurnUp as fasArrowTurnUp,
    faArrowUp as fasArrowUp,
    faArrowUpRightFromSquare as fasArrowUpRightFromSquare,
    faArrowUpWideShort as fasArrowUpWideShort,
    faAsterisk as fasAsterisk,
    faBan as fasBan,
    faBars as fasBars,
    faBell as fasBell,
    faBold as fasBold,
    faBolt as fasBolt,
    faBook as fasBook,
    faBookOpen as fasBookOpen,
    faBox as fasBox,
    faBoxArchive as fasBoxArchive,
    faBoxes as fasBoxes,
    faBoxesStacked as fasBoxesStacked,
    faBoxOpen as fasBoxOpen,
    faBroom as fasBroom,
    faBrush as fasBrush,
    faBug as fasBug,
    faBullhorn as fasBullhorn,
    faCalendarAlt as fasCalendarAlt,
    faCalendarCheck as fasCalendarCheck,
    faCar as fasCar,
    faCaretDown as fasCaretDown,
    faCartPlus as fasCartPlus,
    faCartShopping as fasCartShopping,
    faChartArea as fasChartArea,
    faChartLine as fasChartLine,
    faChartPie as fasChartPie,
    faCheck as fasCheck,
    faCheckCircle as fasCheckCircle,
    faChevronDown as fasChevronDown,
    faChevronLeft as fasChevronLeft,
    faChevronRight as fasChevronRight,
    faChevronUp as fasChevronUp,
    faCircle as fasCircle,
    faCircleCheck as fasCircleCheck,
    faCircleExclamation as fasCircleExclamation,
    faCircleInfo as fasCircleInfo,
    faCircleNotch as fasCircleNotch,
    faCirclePlay as fasCirclePlay,
    faCircleQuestion as fasCircleQuestion,
    faCircleXmark as fasCircleXmark,
    faClock as fasClock,
    faClockRotateLeft as fasClockRotateLeft,
    faClone as fasClone,
    faCloud as fasCloud,
    faCloudArrowDown as fasCloudArrowDown,
    faCloudArrowUp as fasCloudArrowUp,
    faCloudDownloadAlt as fasCloudDownloadAlt,
    faCloudUploadAlt as fasCloudUploadAlt,
    faCode as fasCode,
    faCodeBranch as fasCodeBranch,
    faCodeCompare as fasCodeCompare,
    faCog as fasCog,
    faCogs as fasCogs,
    faCompress as fasCompress,
    faComputer as fasComputer,
    faCopy as fasCopy,
    faCrow as fasCrow,
    faCrown as fasCrown,
    faCube as fasCube,
    faCubes as fasCubes,
    faDatabase as fasDatabase,
    faDiagramProject as fasDiagramProject,
    faDivide as fasDivide,
    faDoorOpen as fasDoorOpen,
    faDownload as fasDownload,
    faDragon as fasDragon,
    faDroplet as fasDroplet,
    faEarthAmericas as fasEarthAmericas,
    faEdit as fasEdit,
    faEgg as fasEgg,
    faEllipsisH as fasEllipsisH,
    faEnvelope as fasEnvelope,
    faExchangeAlt as fasExchangeAlt,
    faExclamationTriangle as fasExclamationTriangle,
    faExpand as fasExpand,
    faExternalLinkAlt as fasExternalLinkAlt,
    faExternalLinkSquareAlt as fasExternalLinkSquareAlt,
    faEye as fasEye,
    faEyeDropper as fasEyeDropper,
    faEyeSlash as fasEyeSlash,
    faFile as fasFile,
    faFileAlt as fasFileAlt,
    faFileArchive as fasFileArchive,
    faFileCircleQuestion as fasFileCircleQuestion,
    faFileExport as fasFileExport,
    faFileImport as fasFileImport,
    faFileInvoice as fasFileInvoice,
    faFileLines as fasFileLines,
    faFileUpload as fasFileUpload,
    faFilter as fasFilter,
    faFingerprint as fasFingerprint,
    faFlag as fasFlag,
    faFloppyDisk as fasFloppyDisk,
    faFolder as fasFolder,
    faFolderOpen as fasFolderOpen,
    faFolderPlus as fasFolderPlus,
    faFolderTree as fasFolderTree,
    faFont as fasFont,
    faForward as fasForward,
    faGamepad as fasGamepad,
    faGaugeHigh as fasGaugeHigh,
    faGear as fasGear,
    faGem as fasGem,
    faGift as fasGift,
    faGlobe as fasGlobe,
    faGrip as fasGrip,
    faGripVertical as fasGripVertical,
    faHandPointer as fasHandPointer,
    faHandshake as fasHandshake,
    faHardDrive as fasHardDrive,
    faHashtag as fasHashtag,
    faHdd as fasHdd,
    faHeadset as fasHeadset,
    faHome as fasHome,
    faHourglassHalf as fasHourglassHalf,
    faHouse as fasHouse,
    faIdBadge as fasIdBadge,
    faIdCard as fasIdCard,
    faInbox as fasInbox,
    faIndustry as fasIndustry,
    faInfoCircle as fasInfoCircle,
    faItalic as fasItalic,
    faKey as fasKey,
    faLayerGroup as fasLayerGroup,
    faLevelUpAlt as fasLevelUpAlt,
    faLifeRing as fasLifeRing,
    faLinkSlash as fasLinkSlash,
    faList as fasList,
    faListCheck as fasListCheck,
    faLocationDot as fasLocationDot,
    faLock as fasLock,
    faLockOpen as fasLockOpen,
    faMagnifyingGlass as fasMagnifyingGlass,
    faMap as fasMap,
    faMapMarkedAlt as fasMapMarkedAlt,
    faMemory as fasMemory,
    faMicrochip as fasMicrochip,
    faMinus as fasMinus,
    faNetworkWired as fasNetworkWired,
    faObjectGroup as fasObjectGroup,
    faPalette as fasPalette,
    faPaperPlane as fasPaperPlane,
    faPaw as fasPaw,
    faPen as fasPen,
    faPencil as fasPencil,
    faPenToSquare as fasPenToSquare,
    faPeopleRoof as fasPeopleRoof,
    faPlay as fasPlay,
    faPlayCircle as fasPlayCircle,
    faPlug as fasPlug,
    faPlugCircleXmark as fasPlugCircleXmark,
    faPlus as fasPlus,
    faPowerOff as fasPowerOff,
    faPuzzlePiece as fasPuzzlePiece,
    faQuestion as fasQuestion,
    faRandom as fasRandom,
    faRectangleXmark as fasRectangleXmark,
    faRedo as fasRedo,
    faRightToBracket as fasRightToBracket,
    faRotate as fasRotate,
    faRotateLeft as fasRotateLeft,
    faRotateRight as fasRotateRight,
    faSatelliteDish as fasSatelliteDish,
    faSave as fasSave,
    faScissors as fasScissors,
    faScrewdriverWrench as fasScrewdriverWrench,
    faSearch as fasSearch,
    faServer as fasServer,
    faShield as fasShield,
    faShieldAlt as fasShieldAlt,
    faShieldHalved as fasShieldHalved,
    faShuffle as fasShuffle,
    faSignature as fasSignature,
    faSignOutAlt as fasSignOutAlt,
    faSitemap as fasSitemap,
    faSkull as fasSkull,
    faSliders as fasSliders,
    faSlidersH as fasSlidersH,
    faSpinner as fasSpinner,
    faSquareCheck as fasSquareCheck,
    faStar as fasStar,
    faStop as fasStop,
    faStopwatch as fasStopwatch,
    faStrikethrough as fasStrikethrough,
    faSync as fasSync,
    faTableCells as fasTableCells,
    faTachometerAlt as fasTachometerAlt,
    faTag as fasTag,
    faTerminal as fasTerminal,
    faTextSlash as fasTextSlash,
    faTextWidth as fasTextWidth,
    faTicket as fasTicket,
    faTimes as fasTimes,
    faToggleOn as fasToggleOn,
    faTowerBroadcast as fasTowerBroadcast,
    faTrash as fasTrash,
    faTrashAlt as fasTrashAlt,
    faTriangleExclamation as fasTriangleExclamation,
    faTruckFast as fasTruckFast,
    faUnderline as fasUnderline,
    faUpload as fasUpload,
    faUpRightFromSquare as fasUpRightFromSquare,
    faUser as fasUser,
    faUserGroup as fasUserGroup,
    faUserMinus as fasUserMinus,
    faUserPlus as fasUserPlus,
    faUsers as fasUsers,
    faUserShield as fasUserShield,
    faUserSlash as fasUserSlash,
    faWandMagicSparkles as fasWandMagicSparkles,
    faWarning as fasWarning,
    faWifi as fasWifi,
    faWrench as fasWrench,
    faX as fasX,
    faXmark as fasXmark
} from '@fortawesome/free-solid-svg-icons';

import {
    faClock as farClock,
    faPaste as farPaste,
    faSquare as farSquare,
    faStar as farStar
} from '@fortawesome/free-regular-svg-icons';

import {
    faBitbucket as fabBitbucket,
    faCloudflare as fabCloudflare,
    faDiscord as fabDiscord,
    faGit as fabGit,
    faGithub as fabGithub,
    faGitlab as fabGitlab,
    faSteam as fabSteam,
    faXbox as fabXbox,
    faYoutube as fabYoutube
} from '@fortawesome/free-brands-svg-icons';

library.add(
    /* SOLID */
    fasAlignLeft, fasArrowDown, fasArrowLeft, fasArrowRight, fasArrowRotateLeft, fasArrowsAlt, fasArrowsRotate, fasArrowTurnUp, fasArrowUp, fasArrowUpRightFromSquare, fasArrowUpWideShort, fasAsterisk, fasBan, fasBars, fasBell, fasBold, fasBolt, fasBook, fasBookOpen, fasBox, fasBoxArchive, fasBoxes, fasBoxesStacked, fasBoxOpen, fasBroom, fasBrush, fasBug, fasBullhorn, fasCalendarAlt, fasCalendarCheck, fasCar, fasCaretDown, fasCartPlus, fasCartShopping, fasChartArea, fasChartLine, fasChartPie, fasCheck, fasCheckCircle, fasChevronDown, fasChevronLeft, fasChevronRight, fasChevronUp, fasCircle, fasCircleCheck, fasCircleExclamation, fasCircleInfo, fasCircleNotch, fasCirclePlay, fasCircleQuestion, fasCircleXmark, fasClock, fasClockRotateLeft, fasClone, fasCloud, fasCloudArrowDown, fasCloudArrowUp, fasCloudDownloadAlt, fasCloudUploadAlt, fasCode, fasCodeBranch, fasCodeCompare, fasCog, fasCogs, fasCompress, fasComputer, fasCopy, fasCrow, fasCrown, fasCube, fasCubes, fasDatabase, fasDiagramProject, fasDivide, fasDoorOpen, fasDownload, fasDragon, fasDroplet, fasEarthAmericas, fasEdit, fasEgg, fasEllipsisH, fasEnvelope, fasExchangeAlt, fasExclamationTriangle, fasExpand, fasExternalLinkAlt, fasExternalLinkSquareAlt, fasEye, fasEyeDropper, fasEyeSlash, fasFile, fasFileAlt, fasFileArchive, fasFileCircleQuestion, fasFileExport, fasFileImport, fasFileInvoice, fasFileLines, fasFileUpload, fasFilter, fasFingerprint, fasFlag, fasFloppyDisk, fasFolder, fasFolderOpen, fasFolderPlus, fasFolderTree, fasFont, fasForward, fasGamepad, fasGaugeHigh, fasGear, fasGem, fasGift, fasGlobe, fasGrip, fasGripVertical, fasHandPointer, fasHandshake, fasHardDrive, fasHashtag, fasHdd, fasHeadset, fasHome, fasHourglassHalf, fasHouse, fasIdBadge, fasIdCard, fasInbox, fasIndustry, fasInfoCircle, fasItalic, fasKey, fasLayerGroup, fasLevelUpAlt, fasLifeRing, fasLinkSlash, fasList, fasListCheck, fasLocationDot, fasLock, fasLockOpen, fasMagnifyingGlass, fasMap, fasMapMarkedAlt, fasMemory, fasMicrochip, fasMinus, fasNetworkWired, fasObjectGroup, fasPalette, fasPaperPlane, fasPaw, fasPen, fasPencil, fasPenToSquare, fasPeopleRoof, fasPlay, fasPlayCircle, fasPlug, fasPlugCircleXmark, fasPlus, fasPowerOff, fasPuzzlePiece, fasQuestion, fasRandom, fasRectangleXmark, fasRedo, fasRightToBracket, fasRotate, fasRotateLeft, fasRotateRight, fasSatelliteDish, fasSave, fasScissors, fasScrewdriverWrench, fasSearch, fasServer, fasShield, fasShieldAlt, fasShieldHalved, fasShuffle, fasSignature, fasSignOutAlt, fasSitemap, fasSkull, fasSliders, fasSlidersH, fasSpinner, fasSquareCheck, fasStar, fasStop, fasStopwatch, fasStrikethrough, fasSync, fasTableCells, fasTachometerAlt, fasTag, fasTerminal, fasTextSlash, fasTextWidth, fasTicket, fasTimes, fasToggleOn, fasTowerBroadcast, fasTrash, fasTrashAlt, fasTriangleExclamation, fasTruckFast, fasUnderline, fasUpload, fasUpRightFromSquare, fasUser, fasUserGroup, fasUserMinus, fasUserPlus, fasUsers, fasUserShield, fasUserSlash, fasWandMagicSparkles, fasWarning, fasWifi, fasWrench, fasX, fasXmark,

    /* REGULAR */
    farClock, farPaste, farSquare, farStar,

    /* BRANDS */
    fabBitbucket, fabCloudflare, fabDiscord, fabGit, fabGithub, fabGitlab, fabSteam, fabXbox, fabYoutube,
);
